import { render, staticRenderFns } from "./AgregarButton.vue?vue&type=template&id=63e954c3&scoped=true&"
import script from "./AgregarButton.vue?vue&type=script&lang=ts&"
export * from "./AgregarButton.vue?vue&type=script&lang=ts&"
import style0 from "./AgregarButton.vue?vue&type=style&index=0&id=63e954c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e954c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('63e954c3', component.options)
    } else {
      api.reload('63e954c3', component.options)
    }
    module.hot.accept("./AgregarButton.vue?vue&type=template&id=63e954c3&scoped=true&", function () {
      api.rerender('63e954c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/AgregarButton.vue"
export default component.exports